import React from "react";

import PrintLogo from "./PrintLogo";
import PrintTitle from "./PrintTitle";
import PrintHeadText from "./PrintHeadText";

const PrintHeader = ({
  title,
  subtitle,
  date,
  shamsiDate,
  printHeadTexts,
  titles,
  changeableDate,
  hideDate,
  landscape,
  logoVariant = "aria",
  textsExtra,
}) => {
  return (
    <>
      {landscape ? (
        <style>{`@page { size: A4 landscape; margin: 7mm 8mm 6mm 8mm; }`}</style>
      ) : null}
      <div className="print-header">
        <PrintTitle
          title={title}
          subtitle={subtitle}
          date={date}
          shamsiDate={shamsiDate}
          titles={titles}
          changeableDate={changeableDate}
          hideDate={hideDate}
        />
        <PrintLogo variant={logoVariant} />
        <PrintHeadText labels={printHeadTexts} extra={textsExtra} />
      </div>
    </>
  );
};

export default PrintHeader;
